import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

export const createReducerManager = (initialReducers) => {
  const reducers = { ...initialReducers }
  let combinedReducer = combineReducers(reducers)
  let keysToRemove = []

  return {
    getReducerMap: () => reducers,
    reduce: (state, action) => {
      if (keysToRemove.length > 0) {
        state = { ...state }
        for (let key of keysToRemove) {
          state[key] = null;
          delete state[key]
        }
        keysToRemove = []
      }
      return combinedReducer(state, action)
    },

    add: (key, reducer) => {
      if (!key || reducers[key]) {
        return
      }
      reducers[key] = reducer
      combinedReducer = combineReducers(reducers)
    },

    remove: key => {
      if (!key || !reducers[key]) {
        return
      }
      delete reducers[key]
      keysToRemove.push(key)
      combinedReducer = combineReducers(reducers)
    }
  }
}

export const configureStore = (initialState, composedEnhancers) => {
  const reducerManager = createReducerManager(rootReducer);
  const store = createStore(reducerManager.reduce, initialState, composedEnhancers)
  store.reducerManager = reducerManager
  return store;
}

const initialState = {};
const enhancers = [];
const middleware = [thunk];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'];

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
const store = configureStore(initialState, composedEnhancers);

export default store;
